export const GET_ALL_MESSAGES = {
    INIT: "GET_ALL_MESSAGES_INIT",
    SUCCESS: "GET_ALL_MESSAGES_SUCCESS",
    ERROR: "GET_ALL_MESSAGES_ERROR"
}